<div class="template-tuner-preview">
  <div class="template-tuner-preview-header">
    <button
      matButton="outlined"
      type="button"
      aria-label="Close preview"
      (click)="closePreview()"
      [disabled]="isCreatingPresentation"
      class="template-tuner-preview-close"
    >
      <mat-icon svgIcon="close" class="!tw-m-0" aria-hidden="true"></mat-icon>
    </button>
  </div>
  <div class="template-tuner-preview-container">
    <div class="template-tuner-preview-iframe-container">
      <presentation-preview
        [templatePreviewHtml]="presentation.content"
        [orientation]="presentation.orientation"
        [disableAutoRefresh]="true"
        [showBranding]="showBranding()"
      ></presentation-preview>
    </div>
    <div class="template-tuner-preview-actions">
      <button
        mat-flat-button
        color="primary"
        type="button"
        (click)="openInEditor()"
        [disabled]="isCreatingPresentation"
      >
        <span *ngIf="!isCreatingPresentation">Edit Presentation</span>
        <span *ngIf="isCreatingPresentation">Creating...</span>
      </button>
    </div>
  </div>
</div>
